import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { Chip } from "@mui/material";
import { ReactComponent as ClockIcon } from "../../assets/images/clock-icon.svg";
import { DateTimeChipWrapper } from "./DateTimeChip.style";
interface DateTimeChipProps {
  timestamp: string;
  isTodaySelected?: boolean;
}

export const DateTimeChip = ({
  timestamp,
  isTodaySelected,
}: DateTimeChipProps) => {
  return (
    <DateTimeChipWrapper>
      <Chip
        data-testid="date-time-chip"
        component={"label"}
        icon={
          isTodaySelected ? (
            <ClockIcon className="color-black" />
          ) : (
            <CalendarTodayOutlinedIcon fontSize="inherit" />
          )
        }
        label={timestamp}
        aria-label={timestamp}
      />
    </DateTimeChipWrapper>
  );
};
